export const GeneralStatus = [
    "ACTIVE",
    "INACTIVE"
];